"use client";
import React from "react";
import "@/app/datenschutz/Datenschutz.css";

import Link from "next/link";
import StickyWidget from "@/common/StickyWidget/StickyWidget";
import { useConsent } from "@/context/ConsentContext";

function Datenschutz({ staticMode = false }) {
  const consentContext = useConsent();
  const openCookieModal = consentContext?.openCookieModal;
  return (
    <div className="Presse">
      <div className="Presse-wrapper">
        {!staticMode && (
          <nav className="Presse-nav">
            <Link href="/" className="transition">
              Startseite
            </Link>
          </nav>
        )}

        <div className="Presse-main">
          <div className="Presse-left">
            <h1>Datenschutzerklärung</h1>
            <p>Hier finden Sie unsere aktuelle Datenschutzerklärung:</p>

            <a
              className="link"
              href="/datenschutzerklärung_pro_autoeinfachlos.pdf"
              download
              target="_blank" // öffnet im neuen Tab
              rel="noreferrer" // empfohlen bei target="_blank"
            >
              Datenschutzerklärung
            </a>

            {!staticMode && (
              <p style={{ marginTop: "24px" }}>
                Cookie einstellung aktualisieren:
              </p>
            )}

            {!staticMode && (
              <p
                className="link"
                style={{ fontWeight: "bold", cursor: "pointer" }}
                onClick={openCookieModal}
              >
                Cookie einstellungen
              </p>
            )}
          </div>

          <div className="Presse-right">
            {!staticMode && <StickyWidget />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Datenschutz;
